import React, {Component} from 'react';
import { addCommasTicks, addCommasTooltip, unix_to_datestring } from '../../../ClientUtils';
import {Line} from 'react-chartjs-2';
import axios from "axios";
const root_string = require("../../../config.json")["root_string"];
const assets = Object.keys(require("../../color_scheme.json"));

class V1_volume_and_gas_prices extends Component {

  constructor(props) {
    super(props);
    this.state = {
      labels: [],
      prices: []
    };
  }
  
  total_volume(datapoint) {
    let total_volume = 0;
    for (let asset of assets) {
      if ((typeof datapoint[asset + "_put"]) === "number") {
        total_volume += datapoint[asset + "_put"];
      }
      if ((typeof datapoint[asset + "_call"]) === "number") {
        total_volume += datapoint[asset + "_call"];
      }
    }
    return total_volume;
  }
  
  async componentDidMount() {
    try {
      const volume_res = await axios.get(root_string + '/api/data_api/V1_weekly_volumes');
      const gas_res = await axios.get(root_string + '/api/data_api/gas_prices');
      let volume_data = {};
      for (let datapoint of volume_res.data["data"]) {
        volume_data[unix_to_datestring(datapoint["timestamp"])] = this.total_volume(datapoint);
      }
      const labels = Object.keys(volume_data);
      let gas_prices = [];
      for (let label of labels) {
        try {
          gas_prices.push(gas_res.data[label]["Value (USD)"]);
        } catch {
          // pass
        }
      }
      this.setState({
        labels: labels,
        gas_prices: gas_prices,
        V1_volumes: Object.values(volume_data)
      })
    } catch (e) {
      this.setState({
        labels: [],
        gas_prices: [],
        V1_volumes: []
      })
      console.log("Error with V2 API");
    }
  };
  
  
  
  render() {
    const data = {
      labels: this.state.labels,
      datasets: [
        {
          label: 'Gas Prices (USD)',
          yAxisID: 'A',
          fill: false,
          lineTension: 0.1,
          borderWidth: 1,
          backgroundColor: 'rgb(203,241,243)',
          borderColor: 'rgb(203,241,243)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgb(203,241,243)',
          pointBackgroundColor: '#cbf1f3',
          pointBorderWidth: 0.5,
          pointHoverRadius: 10,
          pointHoverBackgroundColor: 'rgb(126,176,179)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 0,
          pointHitRadius: 10,
          data: this.state.gas_prices
        },
        {
          label: 'V1 Volume (USD)',
          yAxisID: 'B',
          fill: false,
          lineTension: 0.1,
          borderWidth: 1,
          backgroundColor: 'rgb(31, 155, 163, 0.8)',
          borderColor: 'rgb(31, 155, 163, 0.8)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgb(31, 155, 163, 0.8)',
          pointBackgroundColor: '#cbf1f3',
          pointBorderWidth: 0.5,
          pointHoverRadius: 10,
          pointHoverBackgroundColor: 'rgb(31, 155, 163, 1)',
          pointHoverBorderColor: 'rgba(31, 155, 163, 1)',
          pointHoverBorderWidth: 2,
          pointRadius: 0,
          pointHitRadius: 10,
          data: this.state.V1_volumes
        }
      ]
    };

    const options = {
      tooltips: {
        callbacks: {
          label: addCommasTooltip
        }
      },
      scales: {
        yAxes: [{
          id: 'A',
          type: 'linear',
          position: 'right',
          ticks: {
            autoSkip: true,
            maxTicksLimit: 8
          },
          scaleLabel: {
            display: true,
            labelString: "Gas Price (USD)",
            ticks: {
              fontSize: 15,
              callback: addCommasTicks
            },
            fontSize: 18
          }
        },
          {
            id: 'B',
            type: 'linear',
            position: 'left',
            ticks: {
              autoSkip: true,
              maxTicksLimit: 8,
              callback: addCommasTicks
            },
            scaleLabel: {
              display: true,
              labelString: "Volume (USD)",
              ticks: {
                fontSize: 15
              },
              fontSize: 18
            }
          }],
        xAxes: [{
          type: 'time',
          ticks: {
            autoSkip: true,
            maxTicksLimit: 20
          },
          scaleLabel: {
            display: true,
            labelString: "",
            ticks: {
              fontSize: 10,
            },
            fontSize: 5
          }
        }]
      }
    }
    return (
      <div>
        <h2>Gas Prices and V1 Volumes</h2>
        <Line data={data} options={options} />
      </div>
    );
  }
}

export default V1_volume_and_gas_prices;
